import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { Api } from '@mommy/services/api';

@Injectable({
  providedIn: 'root',
})
export class MemberPostKeepService {
  constructor(private api: Api) {}

  add(post_id: number): Promise<any> {
    const endpoint = `v1/member/action-log/post-keep`;

    return new Promise(async (resolve, reject) => {
      try {
        const params: any = {};
        params.object_id = post_id;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-keep add error', error);
        reject(error);
      }
    });
  }

  remove(post_id: number): Promise<any> {
    const endpoint = `v1/member/action-log/post-keep/remove`;

    return new Promise(async (resolve, reject) => {
      try {
        const params: any = {};
        params.object_id = post_id;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-keep remove error', error);
        reject(error);
      }
    });
  }
}
